import { render, staticRenderFns } from "./MatchInfoDouble.vue?vue&type=template&id=f51413c8&scoped=true"
import script from "./MatchInfoDouble.vue?vue&type=script&lang=js"
export * from "./MatchInfoDouble.vue?vue&type=script&lang=js"
import style0 from "./MatchInfoDouble.vue?vue&type=style&index=0&id=f51413c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51413c8",
  null
  
)

export default component.exports